import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";

import Head from "@/components/Content/Head";

import classes from "../purchase.module.scss";
import { baseFilterOrders } from "./orders_constants";
import { useOrderPaginate } from "@/hooks/purchases/orders";

import Fetching from "@/components/Fetching/Fetching";
import ButtonFilter from "@/components/Filter/ButtonFilter";
import OrdersFilter from "./OrdersFilter";
import OrdersAction from "./Table/Action/OrdersAction";
import OrdersActionSelect from "./Table/Action/OrdersActionSelect";
import BasePagination from "@/components/Pagination/BasePagination";
import OrdersTable from "./Table/OrdersTable";
import { hasPermission } from "@/services/Utils";
import IntegrationLoad from "../Integration/IntegrationLoad";

const Orders = () => {
	const { filter } = useSelector((state) => state.auth);
	const { estate_parent_id, estate_id, type_currency, search, parameter } = filter;

	const [base, setBase] = useState({
		...baseFilterOrders,
		estate_parent_id,
		estate_id,
		type_currency,
		search,
		parameter,
	});
	const [showFilter, setShowFilter] = useState(false);
	const [integrationSelect, setIntegrationSelect] = useState({
		show: false,
		name: "",
		integration: "",
	});

	const { data: response, isLoading: loading, isFetching } = useOrderPaginate(base);

	useEffect(() => {
		setBase({ ...base, estate_parent_id, estate_id, type_currency, search, parameter });
		// eslint-disable-next-line
	}, [estate_parent_id, estate_id, search, parameter, type_currency]);

	const setPage = (value) => setBase({ ...base, page: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	const applyFilter = (params) => {
		let newBase = { ...base };

		if (params.purchaseOrderFilter !== base.purchaseOrderFilter) {
			newBase = {
				...base,
				purchaseOrderFilter: params.purchaseOrderFilter,
			};
		}

		if (params.defaultUnitFilter !== base.defaultUnitFilter) {
			newBase = {
				...base,
				defaultUnitFilter: params.defaultUnitFilter,
			};
		}

		if (params.purchaseClassFilter !== base.purchaseClassFilter) {
			newBase = {
				...base,
				purchaseClassFilter: params.purchaseClassFilter,
			};
		}

		if (params.purchaseStateFilter !== base.purchaseStateFilter) {
			newBase = {
				...base,
				purchaseStateFilter: params.purchaseStateFilter,
			};
		}

		if (params.dateFilter !== base.dateFilter) {
			newBase = {
				...base,
				dateFilter: params.dateFilter,
			};
		}

		if (params.dateToFilter !== base.dateToFilter) {
			newBase = {
				...base,
				dateToFilter: params.dateToFilter,
			};
		}

		setBase(newBase);
		setShowFilter(false);
	};

	if (loading) {
		return <Fetching />;
	}

	return (
		<>
			<Head title={"Compras"} titles={response?.titles} isFetching={isFetching} />

			<ButtonFilter origin="main" size_md={12} showFilter={showFilter} setShowFilter={setShowFilter} />

			<Row className={classes.purchase_global}>
				{showFilter && <OrdersFilter applyFilter={applyFilter} filters={base} />}
				<Col md={showFilter ? 10 : 12} className={classes.purchase_content}>
					<OrdersAction showFilter={showFilter} setShowFilter={setShowFilter} filters={base} setIntegrationSelect={setIntegrationSelect} />

					{response?.list && response?.list?.data?.filter((d) => d.selected).length !== 0 && <OrdersActionSelect />}

					{hasPermission("show", response?.permissions) && <OrdersTable base={base} setBase={setBase} />}

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={response?.list?.last_page}
						quantity={response?.list?.total}
						from={response?.list?.from}
						to={response?.list?.to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<IntegrationLoad integrationSelect={integrationSelect} />
		</>
	);
};

export default Orders;
